const BADGES = [
  { name: 'diamante', image: '/badges/diamante.png' },
  { name: 'safira', image: '/badges/safira.png' },
  { name: 'ouro', image: '/badges/ouro.png' },
  { name: 'prata', image: '/badges/prata.png' },
  { name: 'bronze', image: '/badges/bronze.png' },
  { name: 'light', image: '/badges/light.png' },
];

const BADGE_BY_RANK: Record<number, string> = {
  1: '/badges/bronze.png',
  2: '/badges/prata.png',
  3: '/badges/ouro.png',
  4: '/badges/safira.png',
  5: '/badges/diamante.png',
};

function normalize(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

export function categoryBadge(name: string, rank?: number): string | null {
  const key = normalize(name);
  const byName = BADGES.find((badge) => key === badge.name || key.startsWith(`${badge.name} `));
  if (byName) return byName.image;
  if (rank && BADGE_BY_RANK[rank]) return BADGE_BY_RANK[rank];
  return null;
}
